<template>
  <b-row>
    <b-col class="title">
      <div class="d-flex align-items-center">
        <span class="title-dot title-dot-left"></span>
        <span class="title-dot title-dot-left"></span>
        <span class="title-dot title-dot-left"></span>
        <span class="title-dot title-dot-left"></span>
        <span class="title-dot title-dot-left"></span>
        <span class="title-dot title-dot-left"></span>
        <span class="title-dot title-dot-left"></span>
      </div>
      <div class="d-flex align-items-center f_spec_sc-R"><slot></slot></div>
      <div class="d-flex align-items-center">
        <span class="title-dot title-dot-right"></span>
        <span class="title-dot title-dot-right"></span>
        <span class="title-dot title-dot-right"></span>
        <span class="title-dot title-dot-right"></span>
        <span class="title-dot title-dot-right"></span>
        <span class="title-dot title-dot-right"></span>
        <span class="title-dot title-dot-right"></span>
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'CheckoutHeader',
  props: ['title'],
}
</script>

<style scoped>
  .f_spec_sc-R {
      font-family: 'spectral_sc-R';
  }
  .title {
    display: flex;
    justify-content: center;
    font-family: SourceHanSansCN-ExtraLight;
    font-size: 28px;
    height: 138px;
  }
  .title .title-dot {
    width: 17px;
    height: 12px;
    border: 3px solid #000;
    background-color: #000;
    transform: skewX(-45deg);
  }
  .title .title-dot-left {
    margin-right: 30px;
  }
  .title .title-dot-right {
    margin-left: 30px;
  }
  @media (max-width: 768px) {
    .title {
      font-size: 22px;
      height: 100px;
    }
    .title .title-dot {
      width: 10px;
      height: 10px;
      border: 3px solid #000;
      background-color: #000;
      transform: skewX(-45deg);
    }
    .title .title-dot-left {
      margin-right: 18px;
    }
    .title .title-dot-right {
      margin-left: 18px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/CheckoutHeader.vue